import e from "./_getTag.js";
import r from "./isObjectLike.js";
var o = "[object Set]";
function s(t) {
  return r(t) && e(t) == o;
}
export {
  s as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseIsSet.js
// module id = 1477
// module chunks = 67